import React, { useCallback, useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUploadCloud, FiFile } = FiIcons;

export default function DropZone({ onFileSelect }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setIsDragging(true);
    else if (e.type === 'dragleave') setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (file.name.toLowerCase().endsWith('.zip')) {
        onFileSelect(file);
      } else {
        alert('Please upload a .zip file.');
      }
    }
  }, [onFileSelect]);

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileSelect(e.target.files[0]);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`relative w-full max-w-3xl mx-auto rounded-3xl border-2 border-dashed p-16 transition-all duration-300 ease-in-out flex flex-col items-center justify-center bg-white shadow-xl ${
        isDragging 
          ? 'border-brand-accent bg-brand-light/50 scale-[1.02]' 
          : 'border-slate-300 hover:border-brand-accent hover:bg-slate-50'
      }`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <input
        type="file"
        accept=".zip"
        onChange={handleChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-20"
      />
      <div className="bg-brand-dark/5 p-6 rounded-2xl mb-6 group-hover:bg-brand-accent transition-colors">
        <SafeIcon icon={FiUploadCloud} className="w-10 h-10 text-brand-dark" />
      </div>
      <h3 className="text-2xl font-bold text-brand-dark mb-3">Upload your Project ZIP</h3>
      <p className="text-slate-500 text-center mb-8 max-w-md leading-relaxed">
        Drag and drop your ZIP file containing document packs, or click to browse.
      </p>
      <div className="flex items-center gap-3 text-sm font-semibold text-slate-400 bg-brand-light px-6 py-3 rounded-xl">
        <SafeIcon icon={FiFile} className="w-5 h-5 text-brand-accent" />
        <span>Supports .zip format only</span>
      </div>
    </motion.div>
  );
}